import * as zoneTypeKeys from "../lighting-zone-types/zoneTypeKeys.js";

export const getZoneSortIdx = zoneType => {
  switch (zoneType) {
    case zoneTypeKeys.IO:
      return 1;
    default:
      return 0;
  }
};

export default getZoneSortIdx;
